import React from 'react';

const aboutContent = (
  <div>
    <p>
      Данная услуга позволяет подать апелляцию на&nbsp;результаты ГИА.
      Заявление может быть подано самим участником ГИА или его родителем (законным представителем).
      Срок оказания услуги не&nbsp;превышает 4&nbsp;рабочих дней.
      Допускается отзыв апелляции в&nbsp;течение 24&nbsp;часов после регистрации.
      По&nbsp;итогам рассмотрения апелляции итоговый балл может как увеличиться,
      так и&nbsp;уменьшиться (переоценке подвергается вся работа).
    </p>
  </div>
);

export default aboutContent;
